export default (value: string) => {
  return typeof value === "string" ? value.trim() : value
}
